import { render, staticRenderFns } from "./MallV2GoodsPicker.vue?vue&type=template&id=1b79c3a8&scoped=true"
import script from "./MallV2GoodsPicker.vue?vue&type=script&lang=js"
export * from "./MallV2GoodsPicker.vue?vue&type=script&lang=js"
import style0 from "./MallV2GoodsPicker.vue?vue&type=style&index=0&id=1b79c3a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b79c3a8",
  null
  
)

export default component.exports